<template>
  <a-result status="404" title="404" sub-title="对不起，您访问的页面不存在。">
    <template #extra>
      <a-button type="primary" @click="$router.push({path: '/home'} )">
        Back Home
      </a-button>
    </template>
  </a-result>
</template>

<script>
  import ExceptionPage from './components/ExceptionPage'

  export default {
    components: {
      ExceptionPage
    }
  }
</script>

<style scoped>

</style>
